import React, { useContext, useState } from "react";
import "./LoanCalculator.css";
import { toast } from "react-toastify";
import { BASE_URL } from "../../constants";
import { AuthContext } from "../../utils/AuthContext";

const LoanCalculator = ({ formData, setFormData, handleNextPage }) => {
  const [pricipal, setPricipal] = useState("");
  const [result, setResult] = useState("");
  const [total, setTotal] = useState("");
  const [monthly, setMonthly] = useState("");

  const { user, token, signIn, signOut, profileData, setProfileData } =
    useContext(AuthContext);
  const calculateReturn = () => {
    const principalAmount = parseFloat(pricipal);

    setFormData((prevData) => ({ ...prevData, loan_amount: principalAmount })); // Update formData with school
    console.log("Loan Amount:", principalAmount);

    if (isNaN(principalAmount) || principalAmount <= 0) {
      toast.error("Please enter a valid positive number");
    } else {
      toast.loading("Calculating...");
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append("Authorization", `Token ${token}`);

      const raw = JSON.stringify({
        amount: principalAmount,
        repayment_duration: 1,
      });

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      fetch(`${BASE_URL}loan/calculate-loan/`, requestOptions)
        .then((response) => response.json()) // Parse JSON response
        .then((result) => {
          toast.dismiss();
          const { data } = result; // Destructure the 'data' object from the response
          const { interest, total_amount } = data; // Destructure properties from the 'data' object

          setResult("$ " + interest.toFixed(2)); // Output: The interest value from the response
          setTotal("$ " + total_amount.toFixed(2)); // Output: The total amount value from the response
          setMonthly("$ " + (total_amount / 12).toFixed(2));
        })
        .catch((error) => console.error(error));
    }
  };

  return (
    <div className="sign-up-container">
      <div className="app_olevel">
        <h2 className="font-semibold text-left sm:font-medium text-xl sm:text-3xl">
          Calculate your LOAN
        </h2>
        <p className="center mb-4 font-medium text-lg">LOAN CALCULATOR</p>
        <div className="olevel_form">
          <div className="calculator_div">
            <div>
              <p className="font-semibold">TOTAL LOAN AMOUNT</p>
              <input
                type="number"
                value={pricipal}
                onChange={(e) => setPricipal(e.target.value)}
              />
            </div>
            <div>
              <p className="font-semibold">ANNUAL INTEREST RATE</p>
              <input type="text" placeholder="30%" disabled />
            </div>
            <div>
              <p className="font-semibold">TOTAL REPAYMENT DURATION</p>
              <input type="text" placeholder="72 MONTHS" />
            </div>
          </div>
          <span className="compute">
            <button
              className="btn font-semibold"
              onClick={() => calculateReturn()}
            >
              COMPUTE
            </button>
          </span>
          <div className="calculator_div">
            <div>
              <p className="font-semibold">YOUR MONTHLY PAYMENT</p>
              <input type="text" value={monthly} disabled />
            </div>
            <div>
              <p className="font-semibold">YOUR TOTAL PAYMENT</p>
              <input type="text" value={total} disabled />
            </div>
            <div>
              <p className="font-semibold">YOUR TOTAL INTEREST PAYMENT</p>
              <input type="text" placeholder="" value={result} disabled />
            </div>
          </div>
        </div>
        <button className="wide-btn btn mt-8" onClick={() => handleNextPage()}>
          Next
        </button>
      </div>
    </div>
  );
};

export default LoanCalculator;
